import React, { useEffect, useState } from 'react';
import { postListApi } from '@api/PostApi';
import { PostList } from '@domain';
import styled from '@emotion/styled';

const MainWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const Main = () => {
  const [postList, setPostList] = useState(null);

  useEffect(async () => {
    try {
      const postListData = await postListApi({
        offset: 0,
        limit: 0,
      });

      setPostList(postListData.data);
    } catch (e) {
      console.log(e);
    }
  }, []);

  return (
    <MainWrapper>{postList && <PostList postList={postList} />}</MainWrapper>
  );
};

export default Main;
